module.exports = __webpack_public_path__ + "static/media/GoogleSans-Bold.8066464b.woff2";